import { useTranslation } from 'next-i18next';
import cx from 'classnames';

import { FreeText } from 'components/ComponentV2';

import styles from './AboutEvent.module.scss';

type AboutEventProps = {
  className?: string;
  description: string;
};

export const AboutEvent: React.FC<AboutEventProps> = ({ className, description }) => {
  const [t] = useTranslation('opportunity');

  return (
    <div className={cx(styles.container, className)}>
      <h2 className={styles.title}>{t('about-event.title')}</h2>
      <FreeText content={description} />
    </div>
  );
};
